'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _extends = require('@babel/runtime/helpers/extends');
var react = require('@chakra-ui/react');
var React = require('react');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () {
            return e[k];
          }
        });
      }
    });
  }
  n["default"] = e;
  return Object.freeze(n);
}
var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var React__namespace = /*#__PURE__*/_interopNamespace(React);
var Svg = react.forwardRef(function (props, ref) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends__default["default"]({
    width: "1em",
    height: "1em",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React__namespace.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React__namespace.createElement("rect", {
    fill: "currentColor",
    width: 32,
    height: 32,
    rx: 16
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M23.902 16.093 16.236 8.76A.34.34 0 0 0 16 8.667a.34.34 0 0 0-.236.093l-7.666 7.333a.309.309 0 0 0 0 .451.34.34 0 0 0 .235.094l1.667-.01v6.386c0 .177.15.32.333.32h4a.326.326 0 0 0 .334-.32V18.87h2.666v4.144c0 .177.15.32.334.32h4a.326.326 0 0 0 .333-.32v-6.386l1.667.01a.34.34 0 0 0 .235-.094.309.309 0 0 0 0-.45",
    fill: "#FFF"
  })));
});
var HouseCircled = react.forwardRef(function (props, ref) {
  return /*#__PURE__*/React__namespace.createElement(react.Icon, _extends__default["default"]({
    as: Svg
  }, props, {
    ref: ref
  }));
});
exports.HouseCircled = HouseCircled;